import { Logo } from '@artic/ui/logo';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: IndexPage,
});

function IndexPage() {
  return (
    <div className="flex h-full items-center justify-center">
      <Logo size="xl" />
    </div>
  );
}
